import type { ResourceServiceType } from "@core-ui/ContextServices/ResourceService/ResourceService";
import withObjectUrl from "@core-ui/utils/withObjectUrl";
import getNaturalSize from "@ext/markdown/elements/image/edit/logic/getNaturalSize";

export interface SavedImage {
	src: string;
	width?: string;
	height?: string;
}

export const storeImageFile = async (file: File, fileName: string, resourceService: ResourceServiceType) => {
	const name = `${fileName}.${file.name.split(".").pop()}`;
	return resourceService.setResource(name, Buffer.from(await file.arrayBuffer()));
};

const saveImageFile = async (
	file: File,
	fileName: string,
	resourceService: ResourceServiceType,
): Promise<SavedImage> => {
	const size = await withObjectUrl(file, getNaturalSize);
	const src = await storeImageFile(file, fileName, resourceService);
	return size ? { src, width: `${size.width}px`, height: `${size.height}px` } : { src };
};

export default saveImageFile;
